import Cards from './cardcomponentmedia';
import React from 'react';

const cardtitles = ['Data Science', 'Web Development', 'Machine Learning', 'Data Visualization'];

function FrameworkComponent() {
  return (
    <div className="portfolio-section-light">
      <div className="framework-intro">
        <h2 id="frameworks" className="portfolio-section-title">
          Framework <span style={{ color: "var(--color-accent)" }}>Techniques</span>
        </h2>
        <p className="framework-intro-text">
          Frameworks that I have practiced ranging from machine learning, data science, and web development, differing between several programming languages and disciplines.
        </p>
      </div>

      {/* Cards Grid */}
      <div className="framework-cards-container">
        {cardtitles.map((cardtitle) => Cards(cardtitle))}
      </div>
    </div>
  );
}

export default FrameworkComponent;